import React, { useEffect } from "react"
import { useMatch } from "react-router-dom"
import { oldRoutes } from "router/old-routes"
import FormAntdModal from "components/accounting/FormAntdModal"

// Redux
import { useDispatch } from "react-redux"
import { cleanExpense, getExpense } from "store/accounting"

export default function ExpenseWindow() {
  const dispatch = useDispatch()
  const isPersisted = useMatch(oldRoutes.guideAccountingEditExpancePath())
  const expenseId = isPersisted?.params?.id

  useEffect(() => {
    if (expenseId) dispatch(getExpense(expenseId))
    return () => dispatch(cleanExpense())
  }, [expenseId, dispatch])

  return <FormAntdModal />
}
